// import { createStore, applyMiddleware, compose } from 'redux';
// import thunk from 'redux-thunk';
// import { reduxFirestore, getFirestore, createFirestoreInstance } from 'redux-firestore';
// import rootReducer from './rootReducers';
// import fbConfig from '../config/database/firebase';

// const store = createStore(
//   rootReducer,
//   compose(
//     applyMiddleware(thunk.withExtraArgument({ getFirestore, storage: firebase.storage })),
//     reduxFirestore(fbConfig),
//   ),
// );

// export const rrfProps = {
//   firebase,
//   config: (fbConfig, { useFirestoreForProfile: true, userProfile: 'users', attachAuthIsReady: true }),
//   dispatch: store.dispatch,
//   createFirestoreInstance,
// };

// export default store;

import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './rootReducers';

// Enhancers for the Redux DevTools Extension
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

export default store;
